module.exports = __webpack_public_path__ + "static/media/10.2202040d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/10.jpg
// module id = 917
// module chunks = 0